import { withMobileGuard } from '@utils/guards/withMobileGuard.component'

import { Modal as DesktopModal } from './Modal.component'
import { MobileModal } from './mobile.Modal.component'

export const Modal = withMobileGuard(DesktopModal, MobileModal)
